import {
  Collection,
  Row as AriaRow,
  type RowProps as AriaRowProps,
  useTableOptions,
} from "react-aria-components";
import { tv } from "tailwind-variants";

import { Cell2 } from "@/ui2/atoms/(table)/Cell";
import { Checkbox2 } from "@/components/UI2/atoms/Checkbox";
import { cn } from "@/lib/helpers/cn";

export function Row2<T extends object>({ className, ...props }: AriaRowProps<T>) {
  const { selectionBehavior } = useTableOptions();
  const { row } = styles();

  return (
    <AriaRow className={cn(row(), className)} {...props}>
      {selectionBehavior === "toggle" && (
        <Cell2>
          <Checkbox2 slot="selection" />
        </Cell2>
      )}
      <Collection items={props.columns}>{props.children}</Collection>
    </AriaRow>
  );
}

const styles = tv({
  slots: {
    row: cn(
      "tw:group/row",
      "tw:cursor-default tw:outline-none",
      "tw:transition-colors tw:duration-100",
      "tw:hover:bg-fill-senary",
      "tw:selected:bg-fill-teal-quinary",
    ),
  },
});
